import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyCacheService } from '../services/currency-cache.service';
import {
  formatInstrumentQuantity,
  isInstrumentSymbol,
} from '../helpers/balance.helper';

@Pipe({ name: 'amount', standalone: true })
export class AmountPipe implements PipeTransform {
  /** Missing or non-numeric values render as '-', which `grouped` passes through. */
  transform(value: any, currency: string | null | undefined): string | null {
    if (value === null || value === undefined || value === '') return '-';
    const amount = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (!isFinite(amount)) return '-';
    // Securities positions are not in the currency cache (which would give 0 decimals).
    if (isInstrumentSymbol(currency)) return formatInstrumentQuantity(amount);
    const precision = CurrencyCacheService.getPrecision(currency ?? '');
    return amount.toFixed(precision);
  }
}
